import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import pt from 'date-fns/locale/pt-BR';
import { isSameDay } from 'date-fns';

import Button from '../../../../components/Button';
import ContainerModal from '../../../../components/ContainerModal';

import { ScheduleItemProps } from '../../../../models/Schedule';
import * as S from './styles';
import { ItemToSchedule } from '../../../../contexts/ModuleContext';
import DatePickerHeader from '../DatePickerHeader';
import { LoadingOverlay } from '../../../../components';

registerLocale('pt-BR', pt);

type DatePickerModalProps = {
  schedule?: ScheduleItemProps;
  selectedDate: Date | null;
  setSelectedDate: (date: Date | null) => void;
  displayDates: Date[] | undefined;
  setDisplayDates: (date: Date[]) => void;

  displayDatesPicker: Date[] | undefined;
  onMonthChange: (date: Date) => Promise<void>;
  isOpen: boolean;
  setIsOpen: (visible: boolean) => void;
  loading: boolean;
};

const DatePickerModal = ({
  selectedDate,
  setSelectedDate,
  displayDates,
  setDisplayDates,
  displayDatesPicker,
  onMonthChange,
  isOpen,
  setIsOpen,
  loading
}: DatePickerModalProps) => {
  const firstDateWithSlot = displayDates?.length ? displayDates[0] : undefined;

  const handleSelectDate = (date: Date) => {
    if (displayDates?.length) {
      const displayDatesSummarized = displayDates?.slice(0, 3);
      if (!displayDatesSummarized.some(item => isSameDay(item, date))) {
        const displayDatesSlice = displayDates?.slice(0, 2);
        if (displayDatesSlice) setDisplayDates([...displayDatesSlice, date]);
      }
    }
    setSelectedDate(date);
  };

  return (
    <ContainerModal
      visible={isOpen}
      onClose={() => setIsOpen(false)}
      withoutCloseButton
      childrenFooter={
        <>
          <Button title="Pronto" onClick={() => setIsOpen(false)} />
          <S.ButtonClose tertiary title="Fechar" onClick={() => setIsOpen(false)} />
        </>
      }
    >
      <S.DatePickerWrapper>
        <DatePicker
          calendarClassName="datePicker"
          locale="pt-BR"
          selectsStart={false}
          openToDate={firstDateWithSlot}
          showPreviousMonths={false}
          renderCustomHeader={props => <DatePickerHeader {...props} initialDate={firstDateWithSlot} />}
          selected={selectedDate}
          onChange={handleSelectDate}
          inline
          includeDates={displayDatesPicker}
          onMonthChange={onMonthChange}
          placeholderText="Selecione a data."
        />
      </S.DatePickerWrapper>
      <LoadingOverlay loading={loading} />
    </ContainerModal>
  );
};

export default DatePickerModal;
